import { render, staticRenderFns } from "./avatar-menu.vue?vue&type=template&id=1770a8bc&scoped=true"
import script from "./avatar-menu.vue?vue&type=script&lang=js"
export * from "./avatar-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1770a8bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1770a8bc')) {
      api.createRecord('1770a8bc', component.options)
    } else {
      api.reload('1770a8bc', component.options)
    }
    module.hot.accept("./avatar-menu.vue?vue&type=template&id=1770a8bc&scoped=true", function () {
      api.rerender('1770a8bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main-layout/avatar-menu.vue"
export default component.exports